export default __webpack_public_path__ + "static/MONA-a039702efbe241a0f079f2a9ccbf8e2a.jpg";